/**
 * @module events/options/passive
 */

/**
 * @type {boolean}
 */
export default true
